import { render, staticRenderFns } from "./CmgBagReward.vue?vue&type=template&id=cff00ea0&scoped=true&lang=pug"
import script from "./cmg-bag-reward.ts?vue&type=script&lang=ts&external"
export * from "./cmg-bag-reward.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgBagReward.vue?vue&type=style&index=0&id=cff00ea0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cff00ea0",
  null
  
)

export default component.exports